<template>
  <formsingle v-if="props.data"  :data="props.data" :rules="topoDataRules" @submit="submit"></formsingle>
</template>

<script lang="ts" setup>
import formsingle from '@/components/lanseed/formsingle.vue'
  import {ref,defineEmits,defineProps} from 'vue'
const emits = defineEmits(['update:data'])
const props = defineProps({
  data:{type:Object ,default:()=>{return null}}
})
const topoDataRules=ref<Object>({
  name:{name:'组态名称',required:true},
  'layer.backColor':{name:'背景色',domtype:'color',max:30},
  'layer.backgroundImage':{name:'背景图',domtype:'img'},
  'layer.width':{name:'宽度',domtype:'number',max:2560},
  'layer.height':{name:'高度',domtype:'number',max:2560},
})
const submit=(d)=>{
  emits('update:data',d)
}
</script>
